import { render, staticRenderFns } from "./user_details.vue?vue&type=template&id=35bd9e2f&"
import script from "./user_details.vue?vue&type=script&lang=js&"
export * from "./user_details.vue?vue&type=script&lang=js&"
import style0 from "./user_details.vue?vue&type=style&index=0&id=35bd9e2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports